import {combineReducers} from 'redux'

import userReducer from './user_reducers'
import productsReducer from './products_reducer'

export default combineReducers({
    user:userReducer,
    products:productsReducer
})